module.exports = __webpack_public_path__ + "ba0691c866936ffeeae74d0d546a3e3e.png";